<template>
  <v-container fluid grid-list-lg>
    <v-form ref="form" lazy-validation>
      <v-layout row wrap class="align-end">
        <v-flex>
          <v-img src="/static/ok_logo.png" max-width="200px" contain></v-img>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex>
          <v-layout row wrap justify-end>
            <v-img src="/static/atmone_logo.png" max-width="160px" contain></v-img>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 sm2>
          <span class="font-weight-bold" style="color:#0266a6">Owner</span><br />
          {{ this.ownername }}<br />
          <span class="font-weight-bold" v-if="this.ownerdetails">{{ this.ownerdetails }}<br /></span>
          {{ this.owneraddress1 }}<br />
          {{ this.owneraddress2 }}<br />
          {{ this.ownercity }}, {{ this.ownerstate }}<br />
          {{ this.ownerzipcode }}<br />
          Tel: {{ this.ownerphone1 }}<br />
          Alt Tel: {{ this.ownerphone2 }}<br />
          e: {{ this.email }}
        </v-flex>
        <v-flex xs6 sm2>
          <span class="font-weight-bold" style="color:#326821">Mailing</span><br />
          {{ this.mailingname }}<br />
          {{ this.mailingaddress1 }}<br />
          {{ this.mailingaddress2 }}<br />
          {{ this.mailingcity }}, {{ this.mailingstate }}<br />
          {{ this.mailingzipcode }}
        </v-flex>
        <v-flex xs6 sm2>
          <span class="font-weight-bold" style="color:#d15421">Vehicle</span><br />
          Tag: {{ this.tagnumber }}<br />
          VIN: {{ this.vin }}<br />
          Title: {{ this.titlenumber }}<br />
          Exp: {{ this.monthexpiration }}<br />
          Color: {{ this.vehiclecolor }}
        </v-flex>
        <v-flex xs6 sm2>
          <span class="font-weight-bold" style="color:#a96729">Insurance</span><br />
          Name: {{ this.insurancename }}<br />
          Company: {{ this.insurancecompany }}<br />
          Agent: {{ this.insuranceagentname }}<br />
          NAIC: {{ this.naicnumber }}<br />
          Policy: {{ this.policynumber }}
        </v-flex>
        <v-flex xs6 sm2>
          <span class="font-weight-bold" style="color:#1ea6df">Card</span><br />
          Name: {{ this.cardname }}<br />
          Card: **** **** **** {{ this.cardlastfour }}<br />
          Exp: {{ expiration(this.cardexpiration) }}<br />
          Zip: {{ this.cardzipcode }}
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="trackingID && !hasProcessed">
        <v-flex xs6 sm4>
          <v-text-field
            label="Amount"
            type="tel"
            v-model="fields.amount"
            append-icon="fa-dollar"
            background-color="#aecb9b"
            color="#316120"
            :rules="amountRules"
            maxlength="9"
            box
            hide-details
            required
          />
        </v-flex>
        <v-flex xs6 sm4>
          <v-text-field
            label="Total Amount"
            v-model="totalAmount"
            append-icon="fa-dollar"
            background-color="#edc48e"
            color="#9e5c27"
            box
            hide-details
            readonly
          />
        </v-flex>
      </v-layout>

      <hr class="mt-2 mb-2" style="border: 1px dashed #de9027;" />

      <v-layout row wrap>
        <v-flex xs12>
          <v-textarea
            v-if="trackingID && !hasProcessed"
            label="Notes"
            v-model="fields.notes"
            background-color="#b9d6eb"
            box
            hide-details
            height
            rows="1"
          />
          <template v-else>Notes: {{ this.notes }}</template>
        </v-flex>
      </v-layout>

      <hr class="mt-2 mb-2" style="border: 1px dashed #1ea6df;" />

      <v-layout row wrap align-center fill-height>
        <v-flex xs12 sm4>
          <v-select
            label="Terminal"
            v-model="terminal"
            :items="terminalsCardCanCharge"
            item-text="name"
            item-value="terminal_id"
            box
            hide-details
            required
            v-if="terminalsCardCanCharge.length > 1"
          />
        </v-flex>

        <v-flex xs12 sm8>
          <v-layout row wrap justify-end>
            <v-btn color="primary" @click="process" v-if="trackingID && !hasProcessed">process</v-btn>
            <template v-else><h3>This renewal has already been processed</h3></template>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center>
        <v-flex>
          <v-img src="/static/pci_logo.png" max-height="150px" contain></v-img>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="resultModal" maxWidth="500px" @keydown.esc.prevent="closeResult()" @input="v => v || closeResult()" :transition="false">
      <v-toolbar dense>
        <v-toolbar-title><v-icon v-if="isResponseError">fa-exclamation-triangle</v-icon><v-icon v-if="!isResponseError">fa-check</v-icon> {{ isResponseError ? 'Error' : 'Success' }}</v-toolbar-title>
        <v-spacer/>
        <v-btn icon flat color="primary" @click="closeResult">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card>
        <v-card-text class="text-xs-center">
          <h3 v-if="isResponseError">{{ responseMessage }}</h3>
          <h4 class="primary--text" v-if="isResponseError && responseMessageDetails">{{ responseMessageDetails }}</h4>
          <h3 v-if="!isResponseError">
            The payment for <span class="title primary--text">${{ (transactionDetails.total_amount / 100).toFixed(2) }}</span> has been <span class="title primary--text">approved</span>.
          </h3>
          <h4 class="primary--text" v-if="!isResponseError && responseMessageDetails">{{ responseMessageDetails }}</h4>
        </v-card-text>
        <v-card-actions v-if="!isResponseError">
          <v-layout row wrap align-center justify-space-around>
            <!-- <v-btn @click="receiptModal = true" :disabled="!isProcessing" v-if="!isResponseError">receipt</v-btn> -->
            <v-btn color="primary" @click="printReceipt" v-if="!isResponseError">Print Receipt</v-btn>
            <!-- <v-btn v-if="!isResponseError && fields.billing_email" @click="emailReceipt">Email Receipt</v-btn> -->
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ReceiptPrint ref="receipt" v-bind:transaction="transactionDetails"/>

  </v-container>
</template>

<script>
import Moment from 'moment'

import Bus from '@/bus'
import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'

import ReceiptPrint from '@/components/transactions/ReceiptPrint.vue'
// import JetpayResponse from './JetpayResponse.vue'
// import VCurrencyField from '@/components/addons/VCurrencyField'
// import AmexIcon from '@/../static/cards/visa.svg?inline'
// import Icon from './Icon.vue'

export default {
  mixins: [APIMixin, AuthMixin, CashDiscountMixin, DisplayMixin, StoreMixin, UtilityMixin],
  components: {ReceiptPrint},

  // components: {
  //   'v-currency-field': VCurrencyField
  // },
  // components: { AmexIcon, Icon },
  // icons: {
  //   visa: {
  //     component: AmexIcon
  //   }
  // },

  data: function () {
    return {
      // cardMask: '#### - #### - #### - ####',
      responses: [],

      isProcessing: false,
      responseMessage: '',
      responseMessageDetails: '',
      isResponseError: false,

      resultModal: false,
      receiptModal: false,

      transactionId: 0,
      transactionDetails: {},
      submitNonce: '',

      amountRules: [
        (v) => !!v || 'Amount is required',
        (v) => !isNaN(v) || 'Amount needs to be numeric',
        (v) => (v <= 500000) || 'Amount must be $500,000 or less'
      ],

      current_date: Moment().format('YYYY-MM-DD'),

      selectedTerminal: {},

      hasProcessed: false,

      trackingID: '',

      ownername: '',
      ownerdetails: '',
      email: '',
      license: '',
      owneraddress1: '',
      owneraddress2: '',
      ownercity: '',
      ownerstate: '',
      ownerzipcode: '',
      ownerphone1: '',
      ownerphone2: '',

      mailingsameasowner: false,

      mailingname: '',
      mailingaddress1: '',
      mailingaddress2: '',
      mailingcity: '',
      mailingstate: '',
      mailingzipcode: '',

      tagnumber: '',
      monthexpiration: '',
      vin: '',
      titlenumber: '',
      vehiclecolor: '',

      insurancename: '',
      insuranceagentname: '',
      insurancecompany: '',
      naicnumber: '',
      policynumber: '',

      cardname: '',
      cardlastfour: '',
      cardexpiration: '',
      cardzipcode: '',

      notes: '',

      fields: {
        method: null,
        amount: null,
        fee: 0.00,
        percentage: 0,
        token: null,

        card_name: '',
        card_expiration: '',

        notes: null,
        card_terminal_id: null
      }
    }
  },

  // not logged in, from remote site
  //   login page, redirect back to this page
  // not logged in, from local site
  //   login page, redirect back to this page
  // logged in, from remote site
  // logged in, from local site

  created () {},

  mounted () {
    if (this.$route.params.id) {
      console.log(this.$route.params.id)
      this.reset()
    } else {
      Bus.$emit('openModal', {
        status: 'error',
        message: 'Invalid Request'
      })
    }
  },

  destroyed () {
    this.$store.commit('clearErrors')
    this.$store.commit('clearInfo')
    this.$store.commit('clearSuccesses')
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },

    totalAmount () {
      return Number(this.fields.amount) + Number(this.fields.fee)
    },

    amount () {
      return this.fields.amount
    },

    terminal: {
      get () {
        return this.fields.card_terminal_id
      },
      set (value) {
        this.$set(this.fields, 'card_terminal_id', value)
        this.selectedTerminal = this.terminalsCardCanCharge.find(terminal => terminal.terminal_id === value)
        // this.selectedTerminal = Object.assign({}, this.selectedTerminal, this.terminalsCardCanCharge.find(terminal => terminal.terminal_id === value))
      }
    }
  },

  filters: {
    pretty (data) {
      return JSON.stringify(JSON.parse(JSON.stringify(data)), null, 2)
    },
    localeDate (data) {
      return new Date(data).toLocaleString()
    }
  },

  watch: {
    amount () {
      this.calculateCashDiscountFee()
    }
  },

  methods: {
    async process () {
      try {
        if (!this.$refs.form.validate()) {
          let errors = []
          this.$refs.form.inputs.forEach(e => {
            if (e.hasError) {
              errors.push(e.errorBucket[0])
            }
          })

          let message = 'Validation Error'

          if (errors.length > 1) {
            message = 'Validation Errors'
          }

          Bus.$emit('openModal', {
            status: 'error',
            message: message,
            messageDetails: errors
          })

          return false
        }

        let options = { ...this.fields }

        options.request_type = 'sale'
        options.terminal_id = options.card_terminal_id
        // options.card_month = options.card_expiration.slice(0, 2)
        // options.card_year = options.card_expiration.slice(-2)
        // delete options.card_expiration

        options.nonce = this.submitNonce

        // send account/terminal information
        this.isProcessing = true
        Bus.$emit('openWaitModal')
        let result = await this.api({
          method: 'post',
          url: `/terminal/payment`,
          data: options
        })

        if (result.data.response.ResponseText === 'APPROVED') {
          this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Payment Approved'

          // mark as processed
          await this.api({
            method: 'put',
            url: `/okdmv_renewals/${this.trackingID}`,
            data: {
              id: this.trackingID,
              is_processed: true,
              transaction_tracking_id: this.transactionDetails.tracking_id
            }
          })

          // send receipt
          let email = await this.api({
            method: 'get',
            url: `/transactions/${this.transactionDetails.id}/send_atmone_receipt_email`
          })

          if (email.data && email.data.error === false) {
            this.responseMessageDetails = 'Receipt emailed to customer'
          } else {
            this.responseMessageDetails = 'Problem emailing receipt to customer'
          }

          this.resultModal = true
        } else if (result.data.response.ResponseText === 'PENDING') {
          this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Scheduled Payment Approved'
          this.resultModal = true
        } else if (result.data.response.ResponseText === 'CHECK ACCEPTED') {
          this.transactionDetails = result.data.response.Transaction
          this.responseMessage = 'Payment Accepted'
          this.resultModal = true
        } else {
          let error = result.data.response.ResponseText
          if (result.data.response.ErrMsg) {
            error += ': ' + result.data.response.ErrMsg
          }
          this.transactionDetails = {}
          this.isResponseError = true
          this.responseMessage = error
          this.responseMessageDetails = ''
          this.isProcessing = false

          if (error === 'DECLINED' && this.$route.name === 'ChargeCard') {
            this.responseMessageDetails = 'Please verify card data including the expiration and CVV'
          }

          if (result.data.response.Transaction && result.data.response.Transaction.hasOwnProperty('error_messages') && result.data.response.Transaction.error_messages) {
            let messages = JSON.parse(result.data.response.Transaction.error_messages)

            // show detailed error as long as it isn't the generic 'do not honor'
            if (messages.length > 0 && messages[0] !== 'TRANS DENIED DO NOT HONOR' && messages[0] !== error) {
              this.responseMessageDetails = messages.join()
            }
          }
        }

        Bus.$emit('closeWaitModal')
        this.resultModal = true
        this.responses.unshift(result.data)
      } catch (err) {
        this.isProcessing = false
        this.submitNonce = this.generateId(36)
        Bus.$emit('closeWaitModal')
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    },

    async reset () {
      this.resultModal = false
      this.receiptModal = false

      this.$refs.form.resetValidation()

      this.$store.commit('clearErrors')
      this.$store.commit('clearInfo')
      this.$store.commit('clearSuccesses')

      this.isProcessing = false
      this.responseMessage = ''
      this.responseMessageDetails = ''
      this.isResponseError = false

      this.transactionId = 0
      this.transactionDetails = {}

      this.selectedTerminal = {}

      this.submitNonce = this.generateId(36)

      if (this.terminalsCardCanCharge && this.terminalsCardCanCharge.length) {
        this.terminal = this.terminalsCardCanCharge[0].terminal_id
      }

      if (this.$route.params.id) {
        try {
          let data = await this.api({url: `/okdmv_renewals/${this.$route.params.id}`})

          this.trackingID = data.data.renewalRequest.request_tracking_id
          this.fields.token = data.data.renewalRequest.token_token
          this.fields.card_name = data.data.renewalRequest.billing_name
          this.fields.billing_postalcode = data.data.renewalRequest.billing_postal_code
          this.fields.billing_email = data.data.renewalRequest.billing_email

          this.ownername = data.data.renewalRequest.customer_name
          this.ownerdetails = data.data.renewalRequest.customer_details
          this.email = data.data.renewalRequest.customer_email
          this.license = data.data.renewalRequest.customer_license
          this.owneraddress1 = data.data.renewalRequest.address_address_1
          this.owneraddress2 = data.data.renewalRequest.address_address_2
          this.ownercity = data.data.renewalRequest.address_city
          this.ownerstate = data.data.renewalRequest.address_state
          this.ownerzipcode = data.data.renewalRequest.address_postal_code
          this.ownerphone1 = data.data.renewalRequest.customer_phone
          this.ownerphone2 = data.data.renewalRequest.customer_phone_alt

          this.mailingname = data.data.renewalRequest.address_name
          this.mailingaddress1 = data.data.renewalRequest.address_address_1
          this.mailingaddress2 = data.data.renewalRequest.address_address_2
          this.mailingcity = data.data.renewalRequest.address_city
          this.mailingstate = data.data.renewalRequest.address_state
          this.mailingzipcode = data.data.renewalRequest.address_postal_code

          this.tagnumber = data.data.renewalRequest.tag_number
          this.monthexpiration = data.data.renewalRequest.expire_month
          this.vin = data.data.renewalRequest.vin
          this.titlenumber = data.data.renewalRequest.title_number
          this.vehiclecolor = data.data.renewalRequest.vehicle_color

          this.insurancename = data.data.renewalRequest.insurance_policy_name
          this.insuranceagentname = data.data.renewalRequest.insurance_agent
          this.insurancecompany = data.data.renewalRequest.insurance_company
          this.naicnumber = data.data.renewalRequest.insurance_naic_number
          this.policynumber = data.data.renewalRequest.insurance_policy_number

          this.cardname = data.data.renewalRequest.billing_name
          this.cardlastfour = data.data.renewalRequest.last_four
          this.cardexpiration = data.data.renewalRequest.card_expiration
          this.cardzipcode = data.data.renewalRequest.billing_postal_code

          this.notes = ''

          this.terminal = data.data.renewalRequest.terminal_id

          if (data.data.renewalRequest.request_is_processed) {
            this.hasProcessed = true
          }
        } catch (err) {
          Bus.$emit('openModal', {
            status: 'error',
            message: err
          })
        }
      }
    },

    closeResult () {
      if (!this.isResponseError) {
        if (Object.keys(this.$route.params).length) {
          this.$router.replace('/transactions')
        }

        this.reset()
      } else {
        this.resultModal = false

        this.isProcessing = false
        this.responseMessage = ''
        this.responseMessageDetails = ''
        this.isResponseError = false
      }
    },

    calculateCashDiscountFee () {
      if (!this.fields.amount || Number(this.fields.amount) === 0 || this.fields.amount === '' || this.fields.amount === null) {
        this.fields.fee = 0.00
      } else {
        if (process.env.NODE_ENV !== 'production') {
          console.info('Cash Discount fee in production: ', (Number(this.calculateFee(this.selectedTerminal, this.fields.amount))).toFixed(2))
          this.fields.fee = 0.3
        } else {
          this.fields.fee = (Number(this.calculateFee(this.selectedTerminal, this.fields.amount))).toFixed(2)
        }
      }
    },

    printReceipt () {
      this.$refs.receipt.print()
    },

    async emailReceipt () {
      try {
        if (!this.transactionDetails || !this.transactionDetails.id) {
          throw new Error('Unable to identify transaction')
        }

        let result = await this.api({
          method: 'get',
          url: `/transactions/${this.transactionDetails.id}/send_atmone_receipt_email`
        })

        if (result.data && result.data.error === false) {
          Bus.$emit('openModal', {
            status: 'success',
            message: 'Email Sent'
          })
        } else {
          Bus.$emit('openModal', {
            status: 'error',
            message: 'Unexpected Error'
          })
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/okdmv/Renewal.vue